import { useContext } from 'react'

import { OrganizationContext, type OrganizationContextValue } from './org-context'

export function useOrganization(): OrganizationContextValue {
  const context = useContext(OrganizationContext)
  if (!context) {
    throw new Error('useOrganization must be used inside <OrganizationProvider>')
  }
  return context
}

/**
 * The current organization id, for code that cannot run without one.
 *
 * Throws rather than returning null so a query key can never silently become
 * `[null, 'expenses']` and cache one org's rows under a key another org reads.
 */
export function useOrganizationId(): string {
  const { organization } = useOrganization()
  if (!organization) {
    throw new Error('No organization is selected. Render this inside a protected route.')
  }
  return organization.id
}
